// extracted by mini-css-extract-plugin
export default {"skill":"skills_skill__QFTLP","header":"skills_header__qTwox","name":"skills_name__XspFG","bar":"skills_bar__bMAhg","parameter":"skills_parameter__48U1f"};